<template>
   <div>
    <div class="crumb-container">
      您当前所在位置：{{menuPath | formatPath}}
    </div>
    <!-- <div class="tips"  v-if="showTips">
    <i></i>
    提示：当前产品仅支持孩子王平台下业务活动，暂不支持乐友平台，请知悉
    </div> -->
  </div>
</template>
<script>
  import global from "@/mixins/global";
import Cookies from "js-cookie";
  export default {
    mixins: [global],
    props: {
      url: {
        type: String,
        default: ''
      }
    },
    filters: {
      formatPath(v) {
    
        if (Array.isArray(v) && v.length > 0) {
          return v.join(' / ')
        } else {
          return ''
        }
      },
    },
    computed: {
      showTips() {
    
        // const iframeWindow = iframe.contentWindow
        // const url = iframeWindow.location.href
        // console.log('outLink====>',iframe.src)
        const platformChannel = Cookies.get('platform_channel')
        // 百川里面的页面pure的处理一下， 非pure的自己加一下
        return (platformChannel == '9999' || platformChannel == '2') && this.checkUrlContains(['commoditySpu/createSpuAuto', 'promotion-tools/cart','/promotion-tools/turntable', 'real-time-marketing', 'subsitute-gifts', 'brand-gift-card','sales-adviser-b','stockVisual', 'focusActivity','commentActivity', 'pure/tools/member', 'pure/tools/shareplus','pure/tools/interactive','pure/tools/search', 'pure/tools/point','guestCloudCode', 'tools/activity'])
      }
    },
    methods: {
      checkUrlContains(keywords) {
        if (!this.url) return false
        return keywords.some(keyword => this.url.toLowerCase().includes(keyword.toLowerCase()))
      }
    }
  }
</script>
<style lang="scss" scoped>
  .tips {
    background: #FFF6DF;
    padding: 8px 20px;
    border-radius: 4px;
    color: #F57100;
    margin-bottom: 20px;
    font-family: 600;
    border-radius: 4px;
    display: flex;
    align-items: center;
    i {
      width: 16px;
      height: 16px;
      display: inline-block;
      background: url('https://hzwimspic-1251601690.image.myqcloud.com/1/3b171160-beaa-11ef-a066-f37d37327794_size_24x24') no-repeat center center;
      background-size: 100% 100%;
      margin-right: 8px;
    }
  }
  .crumb-container {
    width: 100%;
    padding: 10px;
    // background: #ffffff;
    font-size: 14px;
    margin-bottom: 10px;
    color: #000000;
  }
</style>
